import './aliases';
import './constants';
import './day-of-month';
import './day-of-week';
import './day-of-year';
import './hour';
import './millisecond';
import './minute';
import './month';
import './offset';
import './priorities';
import './quarter';
import './second';
import './timestamp';
import './week';
import './week-calendar-utils';
import './week-year';
import './year';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/ngx-bootstrap/chronos/units/index.js
// module id = ../../../../ngx-bootstrap/chronos/units/index.js
// module chunks = 4